<script>
import feather from 'feather-icons';
import ContactDetails from '@/components/contact/ContactDetails.vue';

export default {
	components: {
		ContactDetails,
	},
	data: () => {
		return {
			contacts: [
				{
					id: 0,
					name: 'ROYAL TICKETS SRL, CIF: RO32988720',
					icon: 'info',
				},
				{
					id: 1,
					name: 'Str. Nerva Traian, Nr.19A SI 25A, Bl.1, Ap.1003, Sector 3, Bucuresti',
					icon: 'map-pin',
				},
				{
					id: 2,
					name: 'contact@cazinoul.com',
					icon: 'mail',
				}/*,
				{
					id: 3,
					name: '+40725333330',
					icon: 'phone',
				},*/
			],
		};
	},
	mounted() {
		feather.replace();
	},
	updated() {
		feather.replace();
	},
	methods: {},
};
</script>

<template>
	<div
		class="container mx-auto flex flex-col-reverse md:flex-row py-5 md:py-10 md:mt-10"
	>
		<!-- Contact details -->
		<ContactDetails :contacts="contacts" />
	</div>
</template>
